import './style/index.js';

import _Divider from './divider';

export type { DividerProps } from './divider';
export * from './type';

export const Divider = _Divider;
export default Divider;
